// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3IoIz","header":"PatientBlock_header__1C_9g","label":"PatientBlock_label__2Xjoc","option":"PatientBlock_option__2iMQ5"};